import { render, staticRenderFns } from "./SLabel.vue?vue&type=template&id=1b70040c&scoped=true"
import script from "./sLabel.ts?vue&type=script&lang=ts&external"
export * from "./sLabel.ts?vue&type=script&lang=ts&external"
import style0 from "./SLabel.vue?vue&type=style&index=0&id=1b70040c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70040c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b70040c')) {
      api.createRecord('1b70040c', component.options)
    } else {
      api.reload('1b70040c', component.options)
    }
    module.hot.accept("./SLabel.vue?vue&type=template&id=1b70040c&scoped=true", function () {
      api.rerender('1b70040c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-label/SLabel.vue"
export default component.exports